import { useSetupPermission } from "protocol-setup/helpers";
import React from "react";
import { titleAndAria } from "protocol-setup/constants/errorMessages";
import { useFormState } from "react-hook-form";
import { FasUndoAlt, FasSave, FasEnvelope } from 'assets/icons';

const ButtonGroupSignoff = ({
  control,
  formTitle,
  onReset,
  onSendReminder,
  saveLabel = "Submit",
  protectionElement = null,
  protectionElementSR = null
}) => {
  const { isValid, isDirty } = useFormState({ control });
  const hasReminderPermission = useSetupPermission(protectionElementSR);
  const hasSubmitPermission = useSetupPermission(protectionElement);
  

  return (
    <div className="form-layout-actions align-center">
      {hasSubmitPermission && (
        <button
          title={isDirty ? titleAndAria.clearChanges : titleAndAria.noChangesToClear}
          type="button"
          data-testid="reset-button"
          className={`fn-btn mr-2 ${!isDirty ? "disabled color-grey-disabled" : "color-dark-blue"}`}
          aria-label={isDirty ? titleAndAria.clearChanges : titleAndAria.noChangesToClear}
          onClick={() => onReset()}
          disabled={!isDirty}
        >
          <FasUndoAlt />
          Clear Changes
        </button>
      )}

      {hasReminderPermission && onSendReminder && (
        <button
          data-testid="send-reminder-button"
          title={titleAndAria.sendReminder}
          type="button"
          className="btn turquoise mr-1"
          onClick={() => {
            onSendReminder();
          }}
        >
          <FasEnvelope className="ml-n1" />
          Send Reminder
        </button>
      )}

      {hasSubmitPermission && (
        <button
          data-testid="submit-button"
          title={titleAndAria.saveLabel(saveLabel, formTitle)}
          aria-label={titleAndAria.saveLabel(saveLabel, formTitle)}
          type="submit"
          className={`btn ${isDirty && isValid ? "turquoise" : "disabled"} mr-1`}
          disabled={!isDirty || !isValid}
        >
          <FasSave className="ml-n1" />
          {saveLabel}
        </button>
      )}
    </div>
  );
};

export default ButtonGroupSignoff;